module.exports = __webpack_public_path__ + "img/achievement4.f441826f.jpeg";